import Tree from './Tree';
import TreeNode from './TreeNode';

Tree.TreeNode = TreeNode;

export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tree@1.14.3@rc-tree/es/index.js
// module id = 184
// module chunks = 0 1